import { RootState } from '@lon/shared/configs';

export const userRoleCode = (state: RootState) => state.planner.userRoleCode;
